module.exports = __webpack_public_path__ + "search-7ff19ed9a24608cae1b3.svg";